import { getEntityDataAttributes } from "@client/lib/entities";
import { type GenericMap } from "@client/types";

export const getWidgetDataAttributes = (id: string, title: string): GenericMap<string> => {
  const attributes = getEntityDataAttributes(id);

  attributes["data-title"] = title;

  return attributes;
};
